module.exports = __webpack_public_path__ + "public/img/mrcdBg.7fa6ca6c.png";